import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { RootState, select, store } from '../../store'
import styles from './chapter-selector.scss'

const cx = classnames.bind(styles)

interface IState {
  name: string | null
  expandSelector: boolean
  expandUnits: boolean[]
}

interface IProps extends React.HTMLProps<HTMLDivElement> {
  lecture: ILecture | null
  onChapterSelect?: (
    chapter: IChapter,
    unitIdx: number,
    chapterIdx: number
  ) => void
  lectureId: string
}

class ChapterSelector extends React.PureComponent<IProps, IState> {
  public state = {
    name: null,
    expandSelector: false,
    expandUnits: []
  }
  public handleSelectorToggle = () => {
    this.setState({ expandSelector: !this.state.expandSelector })
  }
  public handleUnitClick = (idx: number) => {
    this.setState({
      expandUnits: [
        ...this.state.expandUnits.slice(0, idx),
        !this.state.expandUnits[idx],
        ...this.state.expandUnits.slice(idx + 1)
      ]
    })
  }
  public onChapterClick = (unitIdx: number, chapterIdx: number) => {
    const { lecture, onChapterSelect } = this.props
    if (lecture) {
      const chapter = lecture.units[unitIdx].chapters[chapterIdx]
      if (onChapterSelect) {
        onChapterSelect(chapter, unitIdx, chapterIdx)
      }
      this.setState({
        expandSelector: false,
        name: `觀點 ${unitIdx + 1} ${chapter.title}`
      })
    }
  }
  public componentDidMount = () => {
    const { lecture } = this.props
    const unitLen = lecture ? lecture.units.length : 0
    this.setState({
      expandUnits: new Array(unitLen).fill(false)
    })
  }
  public render() {
    const { className, lecture, lectureId } = this.props
    const { expandSelector, name } = this.state
    const rootState = store.getState()
    const currentUser = firebase.auth().currentUser
    const participants = select.participants.getByLectureId(
      rootState,
      lectureId
    )
    const isParticipant =
      currentUser !== null &&
      participants !== null &&
      R.contains(currentUser.uid, participants)

    return lecture ? (
      <div className={cx('chapter-selector', className)}>
        <div
          onClick={this.handleSelectorToggle}
          className={cx('chapter-selector__backdrop', {
            active: expandSelector
          })}
        />
        <a
          href="#!"
          className={cx('chapter-selector__dropdown-toggle', {
            active: expandSelector
          })}
          onClick={this.handleSelectorToggle}
        >
          {name ? <span>{name}</span> : <span>查看所有觀點</span>}
        </a>
        <div
          className={cx('chapter-selector__dropdown', {
            active: expandSelector
          })}
        >
          <div className={cx('chapter-selector__dropdown__title')}>
            講座觀點
          </div>
          {[lecture.units[0]].map((unit, unitIdx) => (
            <div
              key={unitIdx}
              className={cx('chapter-selector__dropdown__item')}
            >
              {/* <a
                href="#!"
                className={cx({
                  active: expandUnits[unitIdx],
                  toggle: unit.chapters.length > 0
                })}
                onClick={this.handleUnitClick.bind(null, unitIdx)}
              >
                <span className={cx("number")}>{unitIdx + 1}.</span>
                <div>
                  <h5 className={cx("title")}>{unit.title}</h5>
                  {!isParticipant ? (
                    <p className={cx("brief-info")}>
                      <span>可試聽</span>
                      <span>
                        {R.sum(
                          unit.chapters
                            .filter(chapter => chapter.trial)
                            .map(() => 1)
                        )}
                      </span>
                      <span>章節</span>
                    </p>
                  ) : null}
                </div>
              </a> */}
              {// expandUnits[unitIdx] ? unit.chapters.map((chapter, chapterIdx) => (
              unit.chapters.map((chapter, chapterIdx) => (
                <div
                  key={chapterIdx}
                  className={cx('dropdown', { active: true })}
                >
                  <a
                    key={chapterIdx}
                    href="#!"
                    className={cx('dropdown__item')}
                    onClick={this.onChapterClick.bind(
                      null,
                      unitIdx,
                      chapterIdx
                    )}
                  >
                    <span className={cx('number')}>{chapterIdx + 1}.</span>
                    <div>
                      <h5 className={cx('title')}>{chapter.title}</h5>
                      {!isParticipant ? (
                        <p className={cx('brief-info')}>
                          {chapter.trial ? <span>可試聽</span> : null}
                        </p>
                      ) : null}
                    </div>
                  </a>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    ) : null
  }
}

const mapState = ({ participants }: RootState) => ({
  participants
})

export default connect(mapState)(ChapterSelector)



// WEBPACK FOOTER //
// ./src/components/ChapterSelector/index.tsx